import React, { lazy, Suspense } from "react";
import "./../../assets/scss/invoice.scss";
const SalesleadTable = lazy(
  () => import("../../components/table/all-tables/saleslead/SalesleadTable")
);
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import { commonText, salesLeadText } from "../../locales/en";
import ErrorBoundary from "../../components/error-boundary";
import ComponentViewFallback from "../../components/error-boundary/fallback/ComponentViewFallback";

const SalesLead = () => {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle mainTitle={salesLeadText?.mainTitle} />
      <AccessPageAction
        subheading={salesLeadText?.mainTitle}
        createuser="/admin/sales-leads/create"
        createUserTitle={salesLeadText?.createBtn}
      />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mb-3 mx-0">
          <div className="col-12">
            <Suspense fallback={<div>{commonText?.fallbackLoader}</div>}>
              <SalesleadTable />
            </Suspense>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
};

export default SalesLead;
